import { render, staticRenderFns } from "./SocialVote.vue?vue&type=template&id=b34d78d2&"
import script from "./SocialVote.vue?vue&type=script&lang=js&"
export * from "./SocialVote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports